import { render } from "./statusCard.vue?vue&type=template&id=e8ef56de&scoped=true"
import script from "./statusCard.vue?vue&type=script&lang=js"
export * from "./statusCard.vue?vue&type=script&lang=js"

import "./statusCard.vue?vue&type=style&index=0&id=e8ef56de&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ef56de"]])

export default __exports__